import * as api from "../Api";

export const allLocationData = () => async (dispatch) => {
  try {
    const { data } = await api.locationData();
    dispatch({ type: "ALL_LOCATION_DATA", payload: data });
  } catch (error) {}
};
